<template>
  <div class="love-you-club" @wheel.prevent>
    <span class="love-you-club__close" @click="$emit('close')">
      <svg><use xlink:href="#svg-close"></use></svg>
    </span>

    <div class="love-you-club__scroll">
      <LoveYouClubThanks v-if="result?.complete" :result="result" @close="$emit('close')" />
      <div v-else>
        <LoveYouClubHeader :result="result" />
        <LoveYouClubStep :result="result" />
        <LoveYouClubFooter :result="result" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import LoveYouClubThanks from '@components/LoveYouClub/LoveYouClubThanks.vue';
import LoveYouClubHeader from '@components/LoveYouClub/LoveYouClubHeader.vue';
import LoveYouClubStep from '@components/LoveYouClub/LoveYouClubStep.vue';
import LoveYouClubFooter from '@components/LoveYouClub/LoveYouClubFooter.vue';

const { result } = defineProps(['result']);

// onBeforeUnmount(() => {
//     const clubIdId = result?.id;
//     if (clubIdId) window.sessionStorage.setItem(`isLoveYouClubModal${clubIdId}WasShown`, true);
// })
</script>

<script>
export default {
  name: 'LoveYouClub',
};
</script>

<style lang="scss" scoped>
.love-you-club {
  display: flex;
  flex-direction: column;
  padding: 46px 16px 32px;
  @include point-md {
    padding: 48px;
  }

  &__close {
    position: absolute;
    cursor: pointer;
    top: 16px;
    right: 16px;

    svg {
      display: block;
      width: 24px;
      height: 24px;
      @include point-md {
        width: 32px;
        height: 32px;
      }
    }
  }

  &__scroll {
    overflow-y: auto;
    height: 100%;
  }
}
</style>
